export const theme = {
    blue: '#0A2B5E',
    lightBlue: '#2FAAE0'
};

